<template>
  <q-page>
    <div class="row">
      <div class="col-12">
        <q-card>
          <q-card-section>
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                Competitions
              </div>
              <q-btn
                class="q-ml-md"
                color="primary"
                text-color="white"
                no-caps
                @click="newDialog = true"
              >
                <q-icon
                  name="mdi-plus-circle"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Add
              </q-btn>
              <q-btn
                class="q-ml-md"
                color="secondaryButton"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-refresh"
                :loading="dataLoading"
                @click="loadData"
              >
              </q-btn>
              <q-btn
                class="q-ml-md"
                color="secondaryButton"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-filter-outline"
                :loading="dataLoading"
              >
                <q-badge floating>{{ filtersActive }}</q-badge>
                <q-menu>
                  <div class="row q-pa-md">
                    <div class="col-12">
                      <div class="text-h6 q-mb-none">Filters</div>
                    </div>
                    <div class="col-12 q-mb-sm">
                      <q-btn-group flat push class="full-width">
                        <q-btn
                          style="width: 50%"
                          :color="
                            filter.view == 'Live' ? 'accent' : 'secondary'
                          "
                          :text-color="
                            filter.view == 'Live' ? 'secondary' : 'accent'
                          "
                          push
                          label="Live"
                          @click="filter.view = 'Live'"
                        />
                        <q-btn
                          style="width: 50%"
                          :color="
                            filter.view == 'Archived' ? 'accent' : 'secondary'
                          "
                          :text-color="
                            filter.view == 'Archived' ? 'secondary' : 'accent'
                          "
                          push
                          label="Archived"
                          @click="filter.view = 'Archived'"
                        />
                      </q-btn-group>
                    </div>
                    <div class="col-12 q-mb-sm">
                      <q-select
                        :options="[
                          'Northern Region',
                          'Eastern Region',
                          'Central Region',
                          'Southern Region'
                        ]"
                        v-model="filter.region"
                        label="SLS Region"
                        v-bind="siteCFG.fields.general"
                        clearable
                      >
                      </q-select>
                    </div>
                    <div class="col-12 q-mb-sm">
                      <q-select
                        :options="seasons"
                        v-model="filter.season"
                        label="Season"
                        v-bind="siteCFG.fields.general"
                        clearable
                      >
                      </q-select>
                    </div>
                  </div>
                </q-menu>
              </q-btn>

              <q-space />
              <q-input
                style="max-width: 70%"
                filled
                v-model="filter.search"
                debounce="200"
                label="Search"
                clearable
                dense
              >
                <template #prepend>
                  <q-icon name="mdi-magnify"> </q-icon>
                </template>
              </q-input>
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section class="q-pa-none">
            <div v-if="gridData">
              <div class="row">
                <!-- <div class="col-12 my-0 py-0 pl-6">
                  *Double click row to open
                </div> -->

                <div
                  class="col-12 mt-0 pt-0"
                  style="height: calc(100vh - 260px) !important"
                >
                  <datatable
                    :filter="filter"
                    :externalFilter="externalFilter"
                    :flat="true"
                    :data="gridData"
                    :columns="columns"
                    @rowDoubleClick="handleDoubleClick"
                  >
                    <template slot="body-cell-status" slot-scope="data">
                      <q-td
                        :class="{
                          'bg-primary': data.props.row.status == 'DRAFT',
                          'bg-positive': data.props.row.status == 'LIVE',
                          'bg-blue-grey-8': data.props.row.status == 'ARCHIVED'
                        }"
                        class="text-white"
                        :props="data.props"
                      >
                        {{ data.props.row.status }}
                      </q-td>
                    </template>
                    <template slot="body-cell-actions" slot-scope="data">
                      <q-td
                        :class="{
                          currentlyDeployedTD: data.props.value == 1,
                          notDeployedTD: data.props.value != 1
                        }"
                        :props="data.props"
                      >
                        <q-btn round flat color="black">
                          <q-menu>
                            <q-list style="min-width: 100px">
                              <q-item
                                clickable
                                @click="duplicateCompetition(data.props.row.id)"
                                v-close-popup
                              >
                                <q-item-section
                                  >Duplicate with-out Entries</q-item-section
                                >
                              </q-item>
                              <q-separator />
                              <q-item
                                clickable
                                @click="
                                  duplicateCompetition(data.props.row.id, true)
                                "
                                v-close-popup
                              >
                                <q-item-section
                                  >Duplicate with Entries</q-item-section
                                >
                              </q-item>
                            </q-list>
                          </q-menu>
                          <q-icon name="mdi-content-copy"></q-icon>
                          <q-tooltip>Duplicate Competition</q-tooltip>
                        </q-btn>
                        <q-btn
                          v-if="!data.props.row.archived_at"
                          :loading="archivingCompetitionID == data.props.row.id"
                          @click="archiveCompetition(data.props.row.id)"
                          round
                          flat
                          color="negative"
                        >
                          <q-icon name="mdi-archive-arrow-down"></q-icon>
                          <q-tooltip>Archive Competition</q-tooltip>
                        </q-btn>
                        <q-btn
                          v-if="data.props.row.archived_at"
                          :loading="archivingCompetitionID == data.props.row.id"
                          @click="unArchiveCompetition(data.props.row.id)"
                          round
                          flat
                          color="negative"
                        >
                          <q-icon name="mdi-archive-arrow-up"></q-icon>
                          <q-tooltip>Un-archive Competition</q-tooltip>
                        </q-btn>
                        <q-btn
                          :loading="deletingCompetitionID == data.props.row.id"
                          @click="deleteCompetition(data.props.row.id)"
                          round
                          flat
                          color="negative"
                        >
                          <q-icon name="mdi-trash-can-outline"></q-icon>
                          <q-tooltip>Delete Competition</q-tooltip>
                        </q-btn>
                      </q-td>
                    </template>
                  </datatable>
                </div>
              </div>
            </div>
          </q-card-section>
          <!-- <expandedToolbar
            :newButton="true"
            @newButtonClick="newDialog = true"
          /> -->
        </q-card>
      </div>
    </div>
    <q-dialog v-model="newDialog" persistent max-width="90vw">
      <q-card v-if="newDialog" tile style="width: 90vw; max-width: 90vw">
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              New Competition
            </div>
            <q-space />
            <q-btn
              round
              flat
              icon="mdi-close"
              @click="
                newDialog = false;
                newFormData = {};
              "
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="formHeight q-pa-none">
          <q-scroll-area style="height: calc(100vh - 191px) !important">
            <competitionForm
              ref="newForm"
              @close="newDialog = false"
              @loadingStateChanged="state => (createLoading = state)"
            />
          </q-scroll-area>
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.newForm.create()"
                :loading="createLoading"
                color="primary"
                no-caps
                class="float-right"
              >
                <q-icon
                  name="mdi-plus-circle"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Add
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="viewDetailsDialog" persistent max-width="90vw">
      <q-card
        v-if="viewDetailsDialog"
        tile
        style="width: 90vw; max-width: 90vw"
      >
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">Competition</div>
            <q-space />
            <q-btn round flat icon="mdi-close" @click="close"> </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="formHeight q-pa-none">
          <q-scroll-area style="height: calc(100vh - 191px) !important">
            <competitionForm
              ref="editForm"
              :id="viewFormData.id"
              @close="close"
              @loadingStateChanged="state => (saveLoading = state)"
            />
          </q-scroll-area>
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                v-if="$route.name == 'competitionsView'"
                @click="$refs.editForm.save()"
                :loading="saveLoading"
                color="primary"
                no-caps
                class="float-right"
              >
                <q-icon
                  name="mdi-content-save"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Save
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import datatable from "@/components/datatable/datatable.vue";
import competitionForm from "@/components/competitions/competitionForm.vue";
import moment from "moment";

// import { Notify } from "quasar";

export default {
  components: {
    datatable,
    competitionForm
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      gridData: "competitions/list",
      dataLoading: "competitions/listLoading",
      siteCFG: "settings/siteCFG",
      seasons: "settings/availableSeasons"
    }),
    filtersActive: function() {
      let count = 0;
      if (this.filter.region) {
        count += 1;
      }

      if (this.filter.season) {
        count += 1;
      }

      return count;
    }
  },
  data: () => ({
    // data-table
    columns: [
      {
        name: "competition_name",
        label: "Competition",
        align: "left",
        field: "competition_name",
        style:
          "min-width: 250px;max-width: 250px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "start_date",
        label: "Start Date",
        align: "left",
        field: "start_date",
        format: val => (val != null ? moment(val).format("DD-MMM, YYYY") : ""),
        sortable: true
      },
      {
        name: "entriesCloseDate",
        label: "Entries Close Date",
        align: "left",
        field: "entriesCloseDate",
        format: val => (val != null ? moment(val).format("DD-MMM, YYYY") : ""),
        sortable: true
      },
      {
        name: "contactName",
        label: "Contact Name",
        align: "left",
        field: "contactName",
        sortable: true
      },
      {
        name: "status",
        label: "Status",
        align: "left",
        field: "status",
        sortable: true
      },

      {
        name: "actions",
        label: "Actions",
        align: "left",
        sortable: false
      }
    ],

    createLoading: false,

    newDialog: false,

    // View and Edit
    viewFormData: {},
    saveLoading: false,
    viewDetailsDialog: false,

    archivingCompetitionID: null,
    deletingCompetitionID: null,

    // Filter
    filter: {
      search: "",
      view: "Live",
      region: null,
      season: `${
        new Date().getMonth() >= 6 ? moment().year() : moment().year() - 1
      }-${new Date().getMonth() >= 6 ? moment().year() + 1 : moment().year()}`
    },
    filterDialog: false
  }),
  watch: {
    $route: function() {
      this.handleRoute();
    }
  },
  mounted() {
    this.loadData();
    this.handleRoute();
  },
  methods: {
    handleDoubleClick(row) {
      this.$router.push(`${this.$route.path}/${row.id}`);
    },
    loadData() {
      this.$store.dispatch("competitions/loadAll");
    },
    handleRoute() {
      if (this.$route.params.id) {
        this.viewFormData = { id: this.$route.params.id };
        this.$nextTick(() => {
          this.viewDetailsDialog = true;
        });
      } else {
        this.viewDetailsDialog = false;
      }
    },
    deleteCompetition(id) {
      this.$swal({
        title: "Warning",
        text: "You are about to Delete a Competition, do you wish to continue?",
        type: "warning",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        showCancelButton: true,
        confirmButtonColor: "#f58122"
      }).then(res => {
        if (res.value) {
          this.deleteCompetitionID = id;
          this.$store
            .dispatch("competitions/delete", {
              id: id
            })
            .then(result => {
              this.deleteCompetitionID = null;
              if (result.Result == "Success") {
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: "There was an Error, Please try again later"
                });
              }
            });
        }
      });
    },
    archiveCompetition(id) {
      this.$swal({
        title: "Warning",
        text:
          "You are about to Archive a Competition, do you wish to continue?",
        type: "warning",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        showCancelButton: true,
        confirmButtonColor: "#f58122"
      }).then(res => {
        if (res.value) {
          this.archivingCompetitionID = id;
          this.$store
            .dispatch("competitions/archive", {
              id: id
            })
            .then(result => {
              this.archivingCompetitionID = null;
              if (result.Result == "Success") {
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: "There was an Error, Please try again later"
                });
              }
            });
        }
      });
    },
    unArchiveCompetition(id) {
      this.archivingCompetitionID = id;
      this.$store
        .dispatch("competitions/unArchive", {
          id: id
        })
        .then(result => {
          this.archivingCompetitionID = null;
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
        });
    },
    close() {
      this.$router.push("/competitions");
    },

    // Grid Filter
    externalFilter(rows, terms, cols) {
      return rows.filter(row => {
        let passed = 0;

        // Text Search
        if (this.filter.search != "" && this.filter.search) {
          for (let i = 0; i < cols.length; i++) {
            let val = `${row[cols[i].field]}`.toLowerCase();
            passed +=
              val.toLowerCase().indexOf(this.filter.search.toLowerCase()) > -1
                ? 1
                : 0;

            if (passed == 1) {
              i = cols.length;
            }
          }
        } else {
          passed += 1;
        }

        // Archived Filter
        if (
          (this.filter.view == "Live" &&
            !row.archived_at &&
            row.status != "ARCHIVED") ||
          (this.filter.view == "Archived" &&
            (row.archived_at || row.status == "ARCHIVED"))
        ) {
          passed += 1;
        }

        // Region Filter
        if (!this.filter.region || this.filter.region == row.sls_region) {
          passed += 1;
        }

        // Season Filter
        if (this.filter.season) {
          let seasonStart = moment(
            `${this.filter.season.split("-")[0]}-07-01`
          ).startOf("day");
          let seasonEnd = moment(
            `${this.filter.season.split("-")[1]}-06-30`
          ).endOf("day");
          console.log(row.end_date, seasonStart, seasonEnd, this.seasons);
          if (
            (moment(row.end_date) > seasonStart &&
              moment(row.end_date) < seasonEnd) ||
            (this.filter.season == this.seasons[this.seasons.length - 1] &&
              row.end_date == null)
          ) {
            passed += 1;
          }
        } else {
          passed += 1;
        }

        if (passed == 4) {
          return true;
        } else {
          return false;
        }
      });
    },
    duplicateCompetition(id, withEntries = false) {
      const dialog = this.$q.dialog({
        message: "Duplicating",
        progress: true, // we enable default settings
        persistent: true, // we want the user to not be able to close it
        ok: false // we want the user to not be able to close it
      });

      this.$store
        .dispatch("competitions/duplicate", {
          id: id,
          withEntries: withEntries ? 1 : 0
        })
        .then(res => {
          dialog.hide();
          if (res.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: res.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
#depthCard:hover {
  background: #5cb3ff;
  color: white;
}

.formHeight {
  min-height: calc(100vh - 175px);
  max-height: 1000px;
}
</style>
